import type React from "react";
import locationTrackingImage from "../../assets/images/undraw_location-tracking.png"
import { cn } from "../../lib/utils"

interface StatCardProps {
  title: string;
  titleTextColor?: string;
  value: string | number;
  children?: React.ReactNode;
  showImage?: boolean;
}

export function StatsCard({
  title,
  value,
  children,
  showImage,
  titleTextColor
}: StatCardProps) {
  return (
    <div className={cn("bg-white rounded-sm rounded-e-none shadow-md py-6 space-y-2 border-transparent border-b border-solid", titleTextColor ? 'border-b-secondary' : 'border-b-primary')}>
      <h3 className={cn("text-sm font-medium px-6", titleTextColor ? titleTextColor : 'text-primary')}>{title}</h3>
      <div className="flex items-center justify-between px-6">
        <p className="text-4xl font-bold">{value}</p>
        {/* Stat Image */}
          <div className="h-16 w-16 flex items-center justify-center">
         {showImage && (
            <img
              src={locationTrackingImage}
              alt="Location Tracking"
              className="h-full w-full object-contain"
            />
          )}
          </div>
      </div>
      <div>
        {children}
      </div>
    </div>
  );
}
